<template>
  <resource-collection>
    <template slot-scope="{item}">
      <family :family="item"/>
    </template>
  </resource-collection>
</template>

<script>
import Family from './Family.vue';
import collection from '../../mixins/collection';
import ResourceCollection from '../resources/ResourceCollection.vue';

export default {
  mixins: [collection],

  components: { Family, ResourceCollection },

  mounted() {
    Event.listen('familyUpdated', family => this.update(family));
    Event.listen('familyCreated', family => this.prepend(family));
    Event.listen('familyDeleted', family => this.remove(family));
  },
};
</script>